import { render, staticRenderFns } from "./registration-by-brand.page.vue?vue&type=template&id=445412b4"
import script from "./registration-by-brand.page.vue?vue&type=script&lang=ts"
export * from "./registration-by-brand.page.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports